export default __webpack_public_path__ + "e4539e8f84e6deda6f4257db8ef6e72f.svg";